import { jsx as e } from "react/jsx-runtime";
import { useTranslation as o } from "../../../../hooks/useTranslation/index.js";
import { NewCommentFlagContainer as t, PublishingCommentFlagContainer as m, ModeratedCommentFlagContainer as r, DeletedCommentFlagContainer as l } from "./style.js";
const g = () => {
  const { t: n } = o("common");
  return /* @__PURE__ */ e(t, { children: n("new-comment-flag") });
}, d = () => {
  const { t: n } = o("common");
  return /* @__PURE__ */ e(m, { children: n("publishing-comment-flag") });
}, s = () => {
  const { t: n } = o("common");
  return /* @__PURE__ */ e(r, { children: n("moderated-comment-flag") });
}, C = () => {
  const { t: n } = o("common");
  return /* @__PURE__ */ e(l, { children: n("deleted-comment-flag") });
};
export {
  C as DeletedCommentFlag,
  s as ModeratedCommentFlag,
  g as NewCommentFlag,
  d as PublishingCommentFlag
};
